import { styled } from "@mui/material/styles";
import { Box } from "@mui/system";

export const PlaformLaunchContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "100%",
  height: "100%",
  overflowX: "auto",
}));
